import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import session from './session';
import user from './user'
import zwalletReducers from '../ZWallet/reducers';
import orders from 'src/components/Pages/Orders/reducer';
import commissions from 'src/components/Pages/Commissions/reducer'
import order_items from 'src/components/Pages/Items/reducers';
import payments from 'src/components/Pages/Payments/reducers'

const rootReducer = (history) => combineReducers({
  session,
  orders,
  commissions,
  order_items,
  payments,
  user,
  zwallet: zwalletReducers,
  router: connectRouter(history)
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js